import { BarChart } from '@/components/charts/bar-chart';
import { Skeleton } from '@/components/ui/skeleton';
import { formatCurrency, formatNumber } from '@/lib/utils';

import type { FuelSale } from '../dashboard.api';

interface FuelSalesChartProps {
  data: FuelSale[] | undefined;
  loading: boolean;
  height?: number;
}

/** Galones despachados por producto, con el detalle de ventas debajo. */
export function FuelSalesChart({ data, loading, height }: FuelSalesChartProps) {
  if (loading) {
    return <Skeleton className="h-72 rounded-control" />;
  }

  const lista = (data ?? []).filter((item) => item && item.nombre);

  if (lista.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-ink-500">
        Sin despachos registrados en este rango.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <BarChart
        labels={lista.map((item) => item.nombre)}
        series={[{ label: 'Galones', data: lista.map((item) => Number(item.galones || 0)) }]}
        format="gallons"
        height={height}
      />

      <ul className="space-y-1.5 border-t border-ink-100 pt-3">
        {lista.map((item) => (
          <li key={`${item.producto_id}-${item.nombre}`} className="flex items-center justify-between gap-3 text-xs">
            <span className="flex min-w-0 items-center gap-2">
              <span
                aria-hidden="true"
                className="size-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: item.color || '#0ea5e9' }}
              />
              <span className="truncate text-ink-600">{item.nombre}</span>
              <span className="shrink-0 text-ink-400">{formatNumber(item.transacciones)} ops</span>
            </span>

            <span className="flex shrink-0 items-center gap-3">
              <span className="font-mono text-ink-500 tabular-nums">
                {formatNumber(item.galones)} gal
              </span>
              <span className="font-mono font-semibold text-ink-800 tabular-nums">
                {formatCurrency(item.monto)}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
